import Vue from 'vue'
import VueRouter from 'vue-router'
import VuejsDialog from "vuejs-dialog"
import 'vuejs-dialog/dist/vuejs-dialog.min.css';
// import Axios from 'axios'
import main from '../main.js'

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')

// Views - Pages
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
const Register = () => import('@/views/pages/Register')

//Views - Pages SA
const Home = () => import('@/views/Home')
// HTECH-SKIPMA
const HomeInstitutePIC = () => import('@/views/HomeInstitutePIC')
const Login = () => import('@/views/Login')
const ApplicationForm = () => import('@/views/ApplicationForm')
const LoanForm = () => import('@/views/LoanForm')
const SignUp = () => import('@/views/SignUp')
const ApplicationStatus = () => import('@/views/ApplicationStatus')
const Loan = () => import('@/views/ApplicationLoan')
const LandingPage = () => import('@/views/Index')
const ForgotPassword = () => import('@/views/ForgotPassword')
const ChangePassword = () => import('@/views/ChangePassword')
const ResetPassword = () => import('@/views/ResetPassword')
const SlipTemuduga = () => import('@/views/SlipTemuduga')
const SuratTawaran = () => import('@/views/SuratTawaran')
const SuratTawaranSKIPMA = () => import('@/views/SuratTawaranSKIPMA')
const SuratTawaranYTP = () => import('@/views/SuratTawaranYTP')
const SlipPengesahanPelajar = () => import('@/views/SlipPengesahan')
const SlipPengesahanPelajarYTP = () => import('@/views/SlipPengesahanYTP')
const SlipPenawaranYTP = () => import('@/views/SlipPenawaranYTP')
const SlipTemudugaPelajarYTP = () => import('@/views/SlipTemudugaYTP')
const CetakBorangPermohonan = () => import('@/views/CetakBorangPermohonan')
const CetakBorangPermohonanYTP = () => import('@/views/CetakBorangPermohonanYTP')
const AppealForm = () => import('@/views/AppealForm')
const AppealFormYTP = () => import('@/views/AppealFormYTP')
const UploadDocument = () => import('@/views/UploadDocumentPraOffer')
const UploadDocumentVerification = () => import('@/views/UploadDocumentVerification')
const UpdateBankAndGuarantorInformation = () => import('@/views/UpdateBankAndGuarantorInformation')
const ListApplication = () => import('@/views/ListApplication')
const VerificationCode = () => import('@/views/VerificationCode')
const OfferAcceptance = () => import('@/views/OfferAcceptance')
const OfferInterviewAcceptance = () => import('@/views/OfferInterviewAcceptance')
const DokumenPerjanjianV4 = () => import('@/views/DokumenPerjanjianV4')
const PanduanPermohonan = () => import('@/views/PanduanPermohonan')
const SyaratUmum = () => import('@/views/SyaratUmum')
const CoverLetter = () => import('@/views/CoverLetter')
const UploadPanduanPermohonanV4 = () => import('@/views/UploadPanduanPermohonanV4')
const UploadSyaratUmumV4 = () => import('@/views/UploadSyaratUmumV4')
const FinancialAffidavit = () => import('@/views/FinancialAffidavit')
const FinancialStatement = () => import('@/views/FinancialStatement')

const forms = () => import('@/views/base/Forms')

Vue.use(VueRouter)
Vue.use(VuejsDialog);

var router = new VueRouter({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({
    y: 0
  }),
  routes: configRoutes(),
})

router.afterEach(async (to, from, next) => {
  let path = main.$route.path;
  path = path.toLowerCase();

  if (!main.LocallyAuth()) {
    let isAuth = await main.UserAuth();

    if (isAuth == false) {
      if (path != "/login" && path != "/signup" && path != "/verificationcode" && path != "/forgotpassword") {
        main.GoToLogin();
      }
    } else next
  } else if (main.LocallyAuth()) {
    if (path == "/login" || path == "/signup" || path == "/verificationcode" && path != "/forgotpassword") {
      main.GoToHome();
    }
  }
})

function configRoutes() {
  return [{
      path: '/',
      redirect: 'Home',
      name: 'Utama',
      component: DefaultContainer,
      children: [{
          path: 'Home',
          name: 'Permohonan',
          component: Home
        },
        {
          path: 'HomeInstitutePIC',
          name: 'HomeInstitutePIC',
          component: HomeInstitutePIC
        },
        {
          path: 'Login',
          name: 'Log Masuk',
          component: Login
        },
        {
          path: '/base/forms',
          name: 'Log Masuk',
          component: forms
        },
        {
          path: '/Permohonan',
          name: 'Borang Permohonan',
          component: ApplicationForm
        },
        {
          path: '/AppealForm',
          name: 'Borang Rayuan',
          component: AppealForm
        },
        {
          path: '/Permohonan/Pinjaman',
          name: 'Borang Pinjaman',
          component: LoanForm
        },
        {
          path: 'SignUp',
          name: 'Daftar',
          component: SignUp
        },
        {
          path: 'SuratTawaran',
          name: 'Surat Tawaran',
          component: SuratTawaran
        },
        {
          path: 'SuratTawaranSKIPMA',
          name: 'Surat Tawaran SKIPMA',
          component: SuratTawaranSKIPMA
        },
        {
          path: 'SuratTawaranYTP',
          name: 'Surat Tawaran YTP',
          component: SuratTawaranYTP
        },
        {
          path: 'SlipTemuduga',
          name: 'Slip Temuduga',
          component: SlipTemuduga
        },
        {
          path: 'SlipPengesahan',
          name: 'Slip Pengesahan',
          component: SlipPengesahanPelajar
        },
        {
          path: 'SlipPengesahanYTP',
          name: 'Slip Pengesahan YTP',
          component: SlipPengesahanPelajarYTP
        },
        {
          path: 'SlipPenawaranYTP',
          name: 'Slip Penawaran YTP',
          component: SlipPenawaranYTP
        },
        {
          path: 'SlipTemudugaYTP',
          name: 'Slip Temuduga YTP',
          component: SlipTemudugaPelajarYTP
        },
        {
          path: 'CetakBorangPermohonan',
          name: 'Cetak Borang Permohonan',
          component: CetakBorangPermohonan
        },
        {
          path: 'CetakBorangPermohonanYTP',
          name: 'Cetak Borang Permohonan YTP',
          component: CetakBorangPermohonanYTP
        },
        {
          path: 'ApplicationStatus',
          name: 'Status Permohonan',
          component: ApplicationStatus
        },
        {
          path: '/Permohonan/Pinjaman',
          name: 'Borang Permohonan Pinjaman',
          component: Loan
        },
        {
          path: '/Index',
          name: 'Home',
          component: LandingPage
        },
        {
          path: '/ForgotPassword',
          name: 'Forgot Password',
          component: ForgotPassword
        },
        {
          path: '/Pengguna/KataLaluan',
          name: 'Tukar Kata Laluan',
          component: ChangePassword
        },
        {
          path: '/Pengguna/TukarKataLaluan',
          name: 'Tukar Kata Laluan',
          component: ResetPassword
        },
        {
          path: '/Permohonan/Rayuan',
          name: 'Borang Rayuan',
          component: AppealForm
        },
        {
          path: '/Permohonan/AppealFormYTP',
          name: 'Rayuan Kemaskini Maklumat Cadangan Pengajian',
          component: AppealFormYTP
        },
        {
          path: '/Permohonan/Tawaran',
          name: 'Tawaran',
          component: OfferAcceptance
        },
        {
          path: '/Permohonan/TawaranTemuduga',
          name: 'TawaranTemuduga',
          component: OfferInterviewAcceptance
        },
        {
          path: '/Permohonan/UploadDocument',
          name: 'Muat Naik Dokumen',
          component: UploadDocument
        },
        {
          path: '/Permohonan/UploadDocumentVerification',
          name: 'Muat Naik Dokumen',
          component: UploadDocumentVerification
        },
        {
          path: '/Permohonan/UpdateBankAndGuarantorInformation',
          name: 'Kemaskini Maklumat Bank Dan Penjamin',
          component: UpdateBankAndGuarantorInformation
        },
        {
          path: '/ListApplication',
          name: 'Senarai Permohonan',
          component: ListApplication
        },
        {
          path: 'VerificationCode',
          name: 'Pengesahan Kod',
          component: VerificationCode
        },
        {
          path: 'DokumenPerjanjianV4',
          name: 'Dokumen Perjanjian V4',
          component: DokumenPerjanjianV4
        },
        {
          path: 'PanduanPermohonan',
          name: 'Panduan Permohonan',
          component: PanduanPermohonan
        },
        {
          path: 'SyaratUmum',
          name: 'Syarat Umum',
          component: SyaratUmum
        },
        {
          path: 'CoverLetter',
          name: 'Cover Letter',
          component: CoverLetter
        },
        {
          path: 'UploadPanduanPermohonanV4',
          name: 'Upload Panduan Permohonan V4',
          component: UploadPanduanPermohonanV4
        },
        {
          path: 'UploadSyaratUmumV4',
          name: 'Upload Syarat Umum V4',
          component: UploadSyaratUmumV4
        },
        {
          path: 'FinancialAffidavit',
          name: 'Financial Affidavit',
          component: FinancialAffidavit
        },
        {
          path: 'FinancialStatement',
          name: 'Financial Statement',
          component: FinancialStatement
        },
      ]
    },
    {
      path: '/pages',
      redirect: '/pages/404',
      name: 'Pages',
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [{
          path: '404',
          name: 'Page404',
          component: Page404
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500
        },
        {
          path: 'register',
          name: 'Register',
          component: Register
        }
      ]
    }
  ]
}

export default router
